import * as types from './types';

export default {
  /* eslint-disable no-param-reassign */
  [types.SET_ORGANIZATIONS](state, organizations) {
    state.organizations = organizations;
  },
  [types.SET_ORGANIZATIONS_FAILED](state) {
    state.organizations = [];
  },
  [types.GET_TOTALPAGES](state, number) {
    state.totalPages = number;
  },
  [types.GET_TOTALPAGES_FAILED](state) {
    state.totalPages = 1;
  },
  [types.GET_TOTALELMTS](state, number) {
    state.totalElmts = number;
  },
  [types.GET_TOTALELMTS_FAILED](state) {
    state.totalElmts = 0;
  },
  [types.SET_ALL_ORGANIZATIONS](state, list) {
    state.allOrganizations = list;
  },
  [types.SET_ALL_ORGANIZATIONS_FAILED](state) {
    state.allOrganizations = [];
  },
  [types.SET_CURRENT_ORGA](state, orga) {
    state.currentOrga = orga;
  },
  [types.SET_CURRENT_ORGA_FAILED](state) {
    state.currentOrga = {};
  },
  [types.LOAD_STATS_SUCCESS](state, stats) {
    state.stats = stats;
  },
  [types.LOAD_ERROR](state) {
    state.stats = {};
  },
  [types.SET_PATH](state, list) {
    state.groupsPathList = list;
  },
  [types.ADD_TO_PATH](state, item) {
    state.groupsPathList.push(item);
  },
  [types.SLICE_PATH](state, index) {
    state.groupsPathList = state.groupsPathList.slice(0, (index + 1));
  },
  [types.SPLICE_PATH](state, params) {
    state.groupsPathList.splice(params.index, params.spread);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/organizations/mutations.js